<script setup lang="ts">
  import { Toast } from '@lexi-ui-kit/index'
  import { useLoadGTMScript,  } from '@app-common'
  import { useValidateToken } from './composables/useValidateToken'
  import { AuthRoutesNames } from './router'
  import { useRoute } from 'vue-router'
  import { watch } from 'vue'


  useLoadGTMScript(import.meta.env.VITE_GTM_ID || 'GTM-KF2B273R')
  // useLoadFreshdeskWidget()

  const route = useRoute()

  const { validateToken } = useValidateToken()
  const excludedRoutes = [
    AuthRoutesNames.logout,
    AuthRoutesNames.userAgreement,
    AuthRoutesNames.privacyPolicy,
  ]

  watch(
    () => route.name,
    (routeName) => {
      if (routeName && !excludedRoutes.includes(routeName as string)) {
        validateToken()
      }
    },
    { immediate: true }
  )
</script>

<template>
  <div>
    <Toast />
    <Suspense>
      <RouterView />
      <template #fallback>
        <div>Loading...</div>
      </template>
    </Suspense>
  </div>
</template>
